import { CSSTransition } from 'react-transition-group'
import { common } from '@ocean/ui'
import { BannerMessageSettings, MaintenanceInformation } from 'core/system/types'
import { AnimatedBanner, Wrapper, CloseButton } from './BannerNotifications.styled'

const { Icon, Typography } = common

type BannerNotificationsProps = {
  notification?: MaintenanceInformation
  bannerNotification?: BannerMessageSettings
  isShow: boolean
  onClose: Callback
}

const BannerNotifications: React.FC<BannerNotificationsProps> = props => {
  const { bannerNotification, isShow, onClose } = props
  const { bannerMessage } = bannerNotification || {}

  return (
    <CSSTransition in={isShow} classNames='banner' timeout={1000} unmountOnExit>
      <AnimatedBanner>
        <Wrapper>
          <Typography variant='small'>
            <span dangerouslySetInnerHTML={{ __html: bannerMessage || '' }} />
          </Typography>
          <CloseButton onClick={onClose}>
            <Icon icon='close' />
          </CloseButton>
        </Wrapper>
      </AnimatedBanner>
    </CSSTransition>
  )
}

export default BannerNotifications
